import { logout } from "../lib/authBridge.js";
import { retryCurrentUser } from "../lib/userInfo.js";

export default function OrganizationAccessError({ error }) {
    const message = error === "region-unavailable"
        ? "This organization is not available on this dashboard. Open the dashboard for your organization's region, or sign out and sign in with another organization."
        : error === "access-denied"
            ? "Your account cannot open this dashboard. Sign out and sign in with another organization, or contact your administrator."
            : "We could not verify your organization. Try again, or sign out and sign in again. If this continues, contact your administrator.";
    return (
        <main role="alert" className="grid min-h-screen place-items-center bg-[color:var(--bg)] p-[24px] text-[color:var(--ink)]">
            <div className="w-full max-w-[520px] rounded-[2px] border border-[color:var(--line)] bg-[color:var(--control-bg)] px-[14px] py-[16px]">
                <h1 className="text-[10px] uppercase tracking-[0.14em] text-[color:var(--muted-soft)]">Unable to open this dashboard</h1>
                <p className="mt-[6px] text-[12px] leading-[1.5] text-[color:var(--muted)]">{message}</p>
                <div className="mt-[12px] flex flex-wrap gap-[8px]">
                    <button
                        type="button"
                        onClick={() => { void retryCurrentUser(); }}
                        className="cursor-pointer rounded-[2px] border border-[color:var(--line)] px-[8px] py-[3px] text-[10px] uppercase tracking-[0.14em] text-[color:var(--muted-soft)] hover:border-[color:var(--ink)] hover:text-[color:var(--ink)] focus-visible:outline-2 focus-visible:outline-offset-2"
                    >
                        Try again
                    </button>
                    <button
                        type="button"
                        onClick={logout}
                        className="cursor-pointer rounded-[2px] border border-[color:var(--line)] px-[8px] py-[3px] text-[10px] uppercase tracking-[0.14em] text-[color:var(--muted-soft)] hover:border-[color:var(--ink)] hover:text-[color:var(--ink)] focus-visible:outline-2 focus-visible:outline-offset-2"
                    >
                        Sign out and sign in again
                    </button>
                </div>
            </div>
        </main>
    );
}
